import { render, staticRenderFns } from "./CadPromocoes.vue?vue&type=template&id=404f7a5b&"
import script from "./CadPromocoes.vue?vue&type=script&lang=js&"
export * from "./CadPromocoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports